import { z } from "zod";

/**
 * Bulk Delete Schema
 */
export const BulkDeleteSchema = z.object({
  ids: z.array(z.string().min(1)).min(1, "ຕ້ອງເລືອກຢ່າງໜ້ອຍ 1 ລາຍການ"),
});
export type BulkDeleteDTO = z.infer<typeof BulkDeleteSchema>;

/**
 * Bulk Toggle Status Schema
 */
export const BulkToggleStatusSchema = z.object({
  ids: z.array(z.string().min(1)).min(1, "ຕ້ອງເລືອກຢ່າງໜ້ອຍ 1 ລາຍການ"),
  status: z.enum(["active", "inactive"]),
});
export type BulkToggleStatusDTO = z.infer<typeof BulkToggleStatusSchema>;
